import { Action, createReducer, on } from '@ngrx/store';
import { decreaseLoading } from '../utils';
import * as FirmwareActions from './firmwares.actions';
import { Firmware, FirmwareState } from './firmwares.models';

export let firmwareInitialState: FirmwareState = {
    loading: 0,
    firmwares: [],
};

export const firmwareReducer = createReducer(
    firmwareInitialState,
    on(FirmwareActions.loading, (state) => {
        return { ...state, loading: state.loading + 1 };
    }),
    on(FirmwareActions.loadingDone, (state) => {
        return { ...state, loading: decreaseLoading(state.loading) };
    }),
    on(FirmwareActions.loadedFirmwares, (state, { data }) => {
        return {
            ...state,
            firmwares: (data.entries || []).map((e) => new Firmware(e)),
        };
    })
    /**
     * HINT: after CREATE, RELASE and DELETE all firmwares will be loaded again
     */
);

export function firmwares(state = firmwareInitialState, action: Action): FirmwareState {
    return firmwareReducer(state, action);
}
